module.exports = __webpack_public_path__ + "img/ni.585b69e1.svg";